/**
 * FoundingPassCard — the Founding Pass on Today (FREEWEEK-1, Oct 5;
 * kept by OPEN-1, Oct 6).
 *
 * Founders start like everyone else, with the 7-day trial, and the Pass
 * is offered inside the app — here and in Billing — until it closes,
 * instead of being the first thing their email asks for. Shown to a
 * founding member who hasn't bought a Pass; opens their founding page,
 * where the Pass is bought.
 *
 * A Googie glass card (`g-card`): one line of type, one button.
 */
import { Link } from 'react-router-dom';
import { useFoundingOffer } from '@/hooks/useFoundingOffer';
import { PASS_FROM_PRICE } from '@/config/founding';
import { G } from '@/lib/googie';
import { track } from '@/lib/analytics';

const money = (n: number) =>
  `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const shortDay = (d: Date) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export function FoundingPassCard() {
  const { offer } = useFoundingOffer();
  if (!offer) return null;
  return (
    <div className="g-card flex flex-col gap-5 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-7">
      <div className="min-w-0">
        <div className="g-eyebrow" style={{ color: G.mustard }}>
          Founding member
        </div>
        <span className="g-h3 mt-1.5 block">Your Founding Pass is waiting.</span>
        <span className="g-mute mt-1 block text-[15px]">
          Three years of Orbit, paid once — from {money(PASS_FROM_PRICE)}. Open until {shortDay(offer.closesAt)}.
        </span>
      </div>
      <Link
        to={`/founding/${offer.token}`}
        onClick={() => track('founding_cta_clicked', { cta: 'pass', from: 'today' })}
        className="g-pill flex-none no-underline"
      >
        See your Pass
      </Link>
    </div>
  );
}
